import Axios from "axios";

// components
import {View} from "components/lib";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {AuthProvider, PrivateRoute} from "./auth";

// 404
import {NotFound} from "views/error/404";

// tailwind css
import {createContext, useState} from "react";
import "react-dropdown/style.css";
import "../css/output.css";

// settings
const Settings = require("settings.json");

const routes = [
  ...require("routes/account").default,
  ...require("routes/app").default,
  ...require("routes/auth").default,
];


export const ModalContext = createContext({});

export default function App(props) {
  const user = JSON.parse(localStorage.getItem("user"));
  Axios.defaults.baseURL = Settings[process.env.NODE_ENV].server_url;

  if (user?.token) {
    // add auth token to api header calls
    Axios.defaults.headers.common["Authorization"] = "Bearer " + user.token;
  }

  // Handle 304 responses globally
  Axios.interceptors.response.use(
    (response) => {
      // Handle 304 responses as successful (treat them like 200)
      if (response.status === 304 && response.data) {
        response.status = 200;
      }
      return response;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  const [modal, setModal] = useState({});

  // render the routes
  return (
    <ModalContext.Provider value={{modal, setModal}}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {routes.map((route) => {
              return (
                <Route
                  key={route.path}
                  path={route.path}
                  element={
                    route.permission ? (
                      <PrivateRoute permission={route.permission}>
                        <View
                          display={route.view}
                          layout={route.layout}
                          title={route.title}
                        />
                      </PrivateRoute>
                    ) : (
                      <View
                        display={route.view}
                        layout={route.layout}
                        title={route.title}
                      />
                    )
                  }
                />
              );
            })}

            {/* 404 */}
            <Route
              path="*"
              element={
                <View display={NotFound} layout="home" title="404 Not Found"/>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ModalContext.Provider>
  );
}
